module.exports = __webpack_public_path__ + "static/media/user4.7dd644ea.jpeg";